module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal overflow-y-auto modal__overlap in show"
  }, [_c('div', {
    class: ("modal__content modal__content--" + _vm.size)
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop in",
    on: {
      "click": _vm.emitClose
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2547fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/Modal/Modal.vue
// module id = 429
// module chunks = 1